import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface GuideProduct {
  id: string;
  name: string;
  description: string;
  price: number;
  image_url: string;
  slug: string;
}

export function useGuideProduct(plantId: string) {
  const [product, setProduct] = useState<GuideProduct | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchGuideProduct() {
      try {
        setLoading(true);
        setError(null);

        const { data, error } = await supabase
          .from('products')
          .select('*')
          .eq('plant_id', plantId)
          .eq('product_type', 'guide')
          .maybeSingle();

        // Handle the case where no product exists
        if (error) {
          // PGRST116 means no rows found, which is expected when no guide exists
          if (error.code === 'PGRST116') {
            setProduct(null);
            return;
          }
          throw error;
        }

        setProduct(data);
      } catch (err) {
        console.error('Error fetching guide product:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    if (plantId) {
      fetchGuideProduct();
    }
  }, [plantId]);

  return { product, loading, error };
}